import React, { Component } from 'react';
import OriginUpload from 'bee-upload';
import { isFunction, gzip as Gzip, getAppReqParam, getCookie, getGlobalStorage, getTopWindow, Cipher } from '@platform/api';
import Loading from '../Loading';

require('bee-upload/build/Upload.css');

// 由于是从api中导出
const CipherControl = Cipher.default;

let sendChildDate = null; //chendc修改，为了导入的时候使用此参数与进度同步
let cckk = (getTopWindow() && getTopWindow().cookiets) || getCookie('cookiets') || Date.now(); //双cookie验证 liuxis
// 做一次 数据转型
cckk = isNaN(cckk) ? cckk : Number(cckk);
// 加密 bbqin
let cipherFlag = getGlobalStorage('localStorage', 'rockin');
// 将是否加密缓存到组件单例上
CipherControl.CipherFlag = cipherFlag === 'true';

export default class Upload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    // 处理系统变量
    handleSysterm = () => {
        // 从ajax哪里取得，目的获取busiaction
        let { app, appcode } = getAppReqParam();

        let busiaction = `${app || null}-${window.actionName || null}`;
        //chendc修改 上传点击触发setState会导致时间重置，进度标记不再统一
        sendChildDate = sendChildDate || new Date().getTime();

        const sysParamJson = {
            sys_busiaction: busiaction,
            sys_appcode: appcode,
            sys_ts: sendChildDate,
            // busiaction: busiaction ,
            // appcode: appcode,
            // ts: new Date().getTime()
        };

        return sysParamJson;
    };

    uploadChange = info => {
        let { file } = info;

        let {
            status, // 状态 'uploading' 'done' 'error'
            response,
        } = file;
        let { showLoading = true } = this.props;

        if (status == 'uploading' && showLoading) {
            this.setState({
                loading: true,
            });
        } else if (status == 'done') {
            let gzip = getGlobalStorage('localStorage', 'gzip');
            if (gzip == 1) {

                let cckks = this.props.headers ? this.props.headers['crux'] : String(cckk);
                // 先进行 解密处理 bbqin
                let aeskey = Cipher.opaqueDecrypt(getGlobalStorage('localStorage', 'cowboy'));
                aeskey = cckks + aeskey.substring(0, aeskey.length - cckks.length);
                response =
                    typeof response === 'string'
                        ? CipherControl.decrypt(response, aeskey)
                        : response;
                console.log('开始解压');
                let gziptools = new Gzip();
                console.log('压缩开关值：', gzip);
                const unzipData = gziptools.unzip(response);
                console.log('解压数据为:' + unzipData);
                file.response = unzipData;
                console.log('解压完成，处理数据结果：', file);
            }
            if(showLoading){
                this.setState({
                    loading: false,
                });
            }
        }
        if (isFunction(this.props.NcUploadOnChange)) {
            this.props.NcUploadOnChange(info, { sendChildDate });
        }

        if (isFunction(this.props.onChange)) {
            this.props.onChange(info);
        }
        sendChildDate = null;
    };

    render() {
        let { data = {}, headers = {} } = this.props;
        // 传递加密参数
        this.props.headers = this.props.headers || {};
        this.props.headers['crux'] = headers['crux'] = String(headers['crux'] || cckk || (new Date().getTime()));

        const system = this.handleSysterm();

        console.log('外界设置参数属性（props）：', this.props);

        console.log('外界设置data参数：', data);

        return (
            <span>
                <OriginUpload
                    {...this.props}
                    data={{ ...data, ...system }}
                    onChange={this.uploadChange}
                />
                <Loading
                    show={this.state.loading}
                    fullScreen
                />
            </span>


        );
    }
}
// 添加拖拽模式
Upload.Dragger = OriginUpload.Dragger;
